/**
 * name: productsList.js
 * description: 전역으로 사용될 제품목록
 */
export const MAIN_PRODUCTS_LIST = [
  {
    id: 'b3',
    name: '보타랩 슈아멜 바디워시',
    desc: '미세하고 조밀한 버블이 에너지를 부스팅해주는 바디워시',
    hash: '#슈아멜바디워쉬 #보타랩 #데일리바디케어',
    img: 'product_main05.png',
  },
  {
    id: 'b2',
    name: '보타랩 슈아멜 바디스크럽',
    desc: '타이거솔트의 고운입자가 묵은 각질을 부드럽게 케어해주는 바디스크럽',
    hash: '#슈아멜바디스크럽 #보타랩 #데일리바디케어',
    img: 'product_main07.png',
  },
  {
    id: 'b4',
    name: '보타랩 슈아멜 바디크림',
    desc: '생크림 질감의 텍스처가 수분과 영양을 공급하는 미백/주름개선 바디크림',
    hash: '#보타랩 #바디크림 #슈아멜',
    img: 'product_main06.png',
  },
  {
    id: 'h3',
    name: '보타랩 데저티콜라 워터 트리트먼트',
    desc: '워시오프타입 고농축 워터 트리트먼트',
    hash: '#워터트리트먼트 #데저티콜라 #보타랩 #머릿결영양제',
    img: 'product_main03.png',
  },
  {
    id: 'h2',
    name: '보타랩 데저티콜라 샴푸',
    desc: '지친모발과 두피에 에너지를 전달하는 탈모 증상 완화 샴푸',
    hash: '#헤어케어 #데저티콜라샴푸 #보타랩 #샴푸',
    img: 'product_main02.png',
  },

];

// info02는 html로 들어가게 개발
export const PRODUCTS = {
  body: [
    {
      id: 'b1',
      name: '보타랩 슈아멜 바디케어 세트',
      desc01: 'botalab suamel body Care Set',
      desc02: '보타랩 슈아멜만의 특별한 레시피 바디케어 3종 세트',
      info01: '바디크림250ml(8.45 fl.oz.) / 바디스크럽 200g(7.05 oz.) / 바디워시 500ml(16.9 fl.oz.)',
      info02: '바디워시 – 여드름성 피부 완화 기능성 화장품<br>바디크림 – 미백/주름개선 2중 기능성 화장품',
      info03: '모든 피부타입',
      thumbnail: ['product_main04.png'],
      detailimg: 'product_detail04.jpg',
    },
    {
      id: 'b3',
      name: '보타랩 슈아멜 바디워시',
      desc01: 'botalab Suamel Body Wash',
      desc02: '미세하고 조밀한 버블이 에너지를 부스팅해주는 바디워시',
      info01: '500ml(16.9 fl.oz.)',
      info02: '여드름성 피부 완화 기능성 화장품<br>[질병의 예방 및 치료를 위한 의약품이 아님]',
      info03: '모든 피부타입',
      thumbnail: ['product_main05.png'],
      detailimg: 'product_detail05.jpg',
    },
    {
      id: 'b2',
      name: '보타랩 슈아멜 바디스크럽',
      desc01: 'botalab Suamel Body Scrub',
      desc02: '타이거솔트의 고운입자가 묵은 각질을 부드럽게 케어해주는 바디스크럽',
      info01: '200g(7.05 oz.)',
      info02: '.',
      info03: '모든 피부타입',
      thumbnail: ['product_main07.png'],
      detailimg: 'product_detail07.jpg',
    },
    {
      id: 'b4',
      name: '보타랩 슈아멜 바디크림',
      desc01: 'botalab Suamel Body Cream',
      desc02: '생크림 질감의 텍스처가 수분과 영양을 공급하는 미백/주름개선 바디크림',
      info01: '250ml(8.45 fl.oz.)',
      info02: '미백/주름개선 2중 기능성 화장품',
      info03: '모든 피부타입',
      thumbnail: ['product_main06.png'],
      detailimg: 'product_detail06.jpg',
    },
  ],
  hair: [
    {
      id: 'h1',
      name: '보타랩 데저티콜라 헤어케어 세트',
      desc01: 'botalab Deserticola Hair Care Set',
      desc02: '건강한 두피환경 조성을 위한 헤어케어 솔루션 2종 세트',
      info01: '샴푸 500ml(16.9 fl.oz.) / 트리트먼트 300ml(10.14 fl.oz.)',
      info02: '탈모증상 완화 기능성 화장품 <br>[질병의 예방 및 치료를 위한 의약품이 아님]',
      info03: '모든 피부타입',
      thumbnail: ['product_main01.png'],
      detailimg: 'product_detail01.jpg',
    },
    {
      id: 'h2',
      name: '보타랩 데저티콜라 샴푸',
      desc01: 'botalab Deserticola Shampoo',
      desc02: '지친모발과 두피에 에너지를 전달하는 탈모증상 완화 샴푸',
      info01: '500ml(16.9 fl.oz.)',
      info02: '탈모증상 완화 기능성 화장품 <br>[질병의 예방 및 치료를 위한 의약품이 아님]',
      info03: '모든 피부타입',
      thumbnail: ['product_main02.png'],
      detailimg: 'product_detail02.jpg',
    },
    {
      id: 'h3',
      name: '보타랩 데저티콜라 트리트먼트',
      desc01: 'botalab Deserticola Water Treatment',
      desc02: '워시오프타입 고농축 워터 트리트먼트',
      info01: '300ml(10.14 fl.oz.)',
      info02: '탈모증상 완화 기능성 화장품 <br>[질병의 예방 및 치료를 위한 의약품이 아님]',
      info03: '모든 피부타입',
      thumbnail: ['product_main03.png'],
      detailimg: 'product_detail03.jpg',
    },

  ],
};
export const RECOMMENDED_PRODUCTS = ['슈아멜', '데저티콜라'];

export default {
  PRODUCTS,
  RECOMMENDED_PRODUCTS,
  MAIN_PRODUCTS_LIST,
};
